import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m13.066 9.754 3.692-3.691H15.5a.63.63 0 0 1-.656-.657c0-.355.273-.656.656-.656h2.844c.355 0 .656.3.656.656V8.25c0 .383-.3.656-.656.656a.63.63 0 0 1-.657-.656V6.992l-3.69 3.692c-.274.273-.684.273-.93 0a.6.6 0 0 1 0-.903zM8.2 4.804c.52-.136 1.094.11 1.285.63l1.094 2.625c.192.437.082.957-.3 1.257l-1.34 1.121a9.2 9.2 0 0 0 4.374 4.376l1.122-1.34c.3-.383.82-.493 1.257-.301l2.625 1.094c.493.191.766.765.63 1.285l-.657 2.406a1.08 1.08 0 0 1-1.039.793A12.23 12.23 0 0 1 5 6.5c0-.492.328-.902.793-1.04z"
    }, null, -1)
  ]))]))
}
export default { render: render }